import Repository from "@shared/services/api/abstracts/Repository";
import { type UrlRouteMap } from "@shared/services/api/types";
import { AxiosRequestConfig } from "axios";
import { PublicTTSeatPermissionSerializer } from "../types/seating-types";

export default class PublicBasedTTSeatPermissionsRepository extends Repository<
  Array<PublicTTSeatPermissionSerializer>
> {
  public readonly repositoryName = "PublicBasedTTSeatPermissionsRepository";

  public readonly endpoint =
    "/api/public/events/ticket-types/seat-permissions/";

  public get urlMap(): UrlRouteMap {
    return {
      ...this.defaultUrlMap,
      bestAvailable: "best-available",
    };
  }

  public async getPermissions(config: AxiosRequestConfig) {
    const { data } = await this.request(this.buildUrl(), config);
    return data;
  }

  public async getBestAvailable(config: AxiosRequestConfig) {
    const { data } = await this.request(this.buildUrl("bestAvailable"), config);
    return data;
  }
}
